import React, { useEffect } from "react";
import { useState } from "react";
import Layout from "../../components/layout";
import Seo from "../../components/seo";
import ToolCard from "../../components/ToolCard";
import { toolsData } from "../../data/toolsData";

export default function AiToolPage() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const seo = {
    metaDesc: 'Ai Tools Page - Inventiv.org'
  }
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };
  useEffect(() => {
    document?.body.classList.add('no-home');
  }, []);
  return (
    <Layout activeMenu={'builder'}>
      <Seo title="AI Tools Page - Inventiv.org" canonical='/ai-tools' seo={seo} />
      {/* Hero Section */}
      <div class="banner banner-2 bg-light-blue">
        <div class="container">
          <div class="row ">
            <div class="col-12 col-md-6 mt-3">
              <h1 class="sec-clr bold">
                Free Innovation Tools for American Inventors
              </h1>
              <p class="sec-clr">
                Access professional-grade intellectual property and startup valuation tools designed to help inventors protect their ideas and build successful businesses.
              </p>
              <div className='col-12'>
                {/* <a href="https://patent.ewebinar.com/webinar/navigating-patent-process-14153" target="_blank"
                                          className="btn btn-default mr-5px" id="scheduleBtn">Schedule Webinar</a> */}
                <a
                  onClick={() => scrollToSection('tools')}
                  className="btn btn-default me-2"
                >
                  Explore Tools
                </a>
                <a
                  onClick={() => scrollToSection('about')}
                  className="btn btn-secondary"
                >
                  Learn More
                </a>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-3">
              <img style={{ width: '90%' }}
                src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&h=600"
                alt="American inventors collaborating in innovation lab"
                className="rounded-xl shadow-2xl w-full h-auto"
                data-testid="img-hero"
              />
            </div>

          </div>
        </div>
      </div>


      {/* Tools Section */}
      <section id="tools" className="py-20 bg-inventiv-gray my-5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-bold text-inventiv-dark-gray mb-4">Free Innovation Tools</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Access professional-grade tools to evaluate, protect, and maximize the value of your intellectual property assets.
            </p>
          </div>

          <div className="space-y-16">
            {toolsData.map((tool, index) => (
              <ToolCard
                index={index}
                key={tool.id}
                title={tool.title}
                description={tool.description}
                features={tool.features}
                icon={tool.icon}
                image={tool.image}
                imageAlt={tool.imageAlt}
                buttonUrl={tool.buttonUrl}
                reverseLayout={tool.reverseLayout}
              />
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="about" className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1200&h=400"
              alt="American inventors brainstorming in collaborative workspace"
              className="rounded-2xl shadow-xl w-full h-64 object-cover mb-12"
              data-testid="img-cta"
            />
            {/* <div className="absolute inset-0 bg-inventiv-dark-gray/80 rounded-2xl flex items-center justify-center">
              <div className="text-white text-center">
                <h2 className="text-3xl lg:text-4xl font-bold mb-4 text-white">Ready to Protect Your Innovation?</h2>
                <p className="text-xl text-gray-200 mb-6">Join thousands of American inventors who trust our tools</p>
                <button
                  onClick={() => scrollToSection('tools')}
                  className="btn btn-secondary text-white font-semibold shadow-lg px-8 py-4 h-auto"
                  data-testid="button-get-started"
                >
                  Get Started Free
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </section>

    </Layout>
  );
}
